// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__Nh6ud","shortcut-links":"Sidebar_shortcut-links__Enrdf","shortcut-link":"Sidebar_shortcut-link__HA9Up","sidebar-text":"Sidebar_sidebar-text__bUm+V"};